import { render } from "./WidgetRede.vue?vue&type=template&id=148dfa5d&scoped=true"
import script from "./WidgetRede.vue?vue&type=script&lang=js"
export * from "./WidgetRede.vue?vue&type=script&lang=js"

import "./WidgetRede.vue?vue&type=style&index=0&id=148dfa5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148dfa5d"]])

export default __exports__